import { Media, MediaContextProvider } from '../Media'
import Desktop from './Desktop'
import Tablet from './Tablet'
import Phone from './Phone'

// WIP
const ModuleMedallistPage = ({
  moduleSpecificProps: { medallistData }
}: {
  moduleSpecificProps: { medallistData: any }
}) => {
  return (
    <MediaContextProvider>
      <Media lessThan='md'>
        <Phone medallistData={medallistData} />
      </Media>
      <Media between={['md', 'lg']}>
        <Tablet medallistData={medallistData} />
      </Media>
      <Media greaterThanOrEqual='lg'>
        <Desktop medallistData={medallistData} />
      </Media>
    </MediaContextProvider>
  )
}

export default ModuleMedallistPage
